import React, { useState } from "react";
// Common Components
import TabBox from "src/Components/Tabbox/TabBox";
// Local Components
import Portfo from "./Portfo/Portfo";
import Wallet from "./Wallet";
import GeneralView from "./GeneralView";
import Margin from "./Margin";
import ShortCoveredCall from "./ShortCoveredCall";
import CoveredSummary from "./CoveredSummary";
import AssetPercentage from "./AssetPercentage";
import LiquidityManagement from "./LiquidityManagement";
import { isCustomerUser } from "src/helper";

enum ActiveTab {
  Protfo,
  Wallet,
  GeneralView,
  Margin,
  ShortCoveredCall,
  CoveredSummary,
  AssetPercentage,
  LiquidityManagement,
}

const Portfolio = () => {
  const isCustomer = isCustomerUser();
  const [activeTab, setActiveTab] = useState(ActiveTab.Protfo);

  if (isCustomer) {
    return (
      <div className="portfolio-groups-page ime-portfo-page flex flex-col justify-start items-start gap-3 borderrounded w-full p-3 h-full">
        <Portfo />
      </div>
    );
  }

  const getUI = () => {
    switch (activeTab) {
      case ActiveTab.Protfo:
        return <Portfo />;
      case ActiveTab.GeneralView:
        return <GeneralView />;
      case ActiveTab.AssetPercentage:
        return <AssetPercentage />;
      case ActiveTab.Margin:
        return <Margin />;
      case ActiveTab.ShortCoveredCall:
        return <ShortCoveredCall />;
      case ActiveTab.CoveredSummary:
        return <CoveredSummary />;
      case ActiveTab.Wallet:
        return <Wallet />;
      case ActiveTab.LiquidityManagement:
        return <LiquidityManagement />;
      default:
        return <></>;
    }
  };

  return (
    <div className="portfolio-groups-page ime-portfo-page flex flex-col justify-start items-start gap-3 borderrounded w-full p-3 h-full">
      <div className="max-w-min ml-5">
        <TabBox
          activeTab={activeTab}
          children={[
            { index: ActiveTab.Protfo, title: "پورتفو" },
            { index: ActiveTab.GeneralView, title: "نمای کلی" },
            { index: ActiveTab.AssetPercentage, title: "تسهیم دارایی" },
            { index: ActiveTab.Margin, title: "مارجین" },
            { index: ActiveTab.ShortCoveredCall, title: "خلاصه شورت‌کال" },
            { index: ActiveTab.CoveredSummary, title: "خلاصه پوشش" },
            { index: ActiveTab.Wallet, title: "کیف پول" },
            { index: ActiveTab.LiquidityManagement, title: "مدیریت نقدینگی" },
          ]}
          onChange={(_, i) => setActiveTab(i)}
        />
      </div>
      {getUI()}
    </div>
  );
};

export default Portfolio;
